import { render, staticRenderFns } from "./MSecondaryDomainUnsubscribe.vue?vue&type=template&id=8e38d19a&"
import script from "./MSecondaryDomainUnsubscribe.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryDomainUnsubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports